define('SageDotCom/DataLayer/Global/pageVisuals',['jquery',
    'SageDotCom/DataLayer/tealium'],
    function ($, tealium) {
        function pageVisuals() { }

        // rip out the background image url from a background-image style on an element
        function getBackgroundImage(elem) {
            if (elem) {
                var style = $(elem).css('background-image');
                if (style) {
                    style = decodeURIComponent(style);

                    // if there's a background style on the element, then it will be like: url("http://..."), so we
                    // need to strip out the 'url("")' parts.
                    return style.slice(4, -1).replace(/"/g, '');
                }
            }
            return null;
        }


        function getHeroThumbnail() {
            var thumb = $(".score-hero-image:first img").attr('src');
            if (thumb)
                return decodeURIComponent(thumb);
            return null;
        }

        pageVisuals.prototype.initialize = function initialize() {
            var heroText = '(not set)';
            var heroImage = '(not set)';

            var $hero = $(".score-hero, .score-document-header, .score-document-header-with-subtitle, h1").first();

            if ($hero) {
                heroText = $("h1", $hero).text() || $("h2", $hero).text() || $hero.text();
                heroText = heroText.replace(/\n/g, ' '); // newline characters
                heroText = heroText.replace(/ +(?= )/g, ''); // remove multiple spaces
                heroText = heroText.trim();

                var $stripe = $hero.closest(".score-pic-stripe, .score-stripe").first();

                heroImage = getBackgroundImage($stripe) || getHeroThumbnail() || '(not set)';
            }

            var eventSchema = {
                'page_hero_text': heroText,
                'page_hero_image_name': heroImage,
                'page_rich_content_type': '(not set)',
                'page_rich_content_id': '(not set)',
                'page_rich_content_name': '(not set)'
            };
            tealium.registerPageData(eventSchema);
        }

        return new pageVisuals();
    });
